module.exports = __webpack_public_path__ + "static/defaultNewsImage-682fb6333955b82a7c8f3e526018cadd.png";